import React, { PureComponent } from 'react'
import { Table, Button } from 'react-bootstrap'
import StatusLabel from '../accreditation_status/status_label'

class TXDetailsAccreditedStatus extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      copyText: 'Copy Link',
      copyClass: 'success',
    }
  }

  /**
   * @todo this is a duplication, needs to be generalized
   * @todo should utilize environment variables instead of relying on sub-domain string
   */
  generateLink = () => {
    const subdomain = window.location.hostname.split('.')[0]
    let linkSub = 'kyc'
    if (subdomain === 'dev-compliance') {
      linkSub = 'dev-kyc'
    }
    const baseUrl = 'https://' + linkSub + '.myverify.info/accredited-form/'
    const identityID = this.props.identity.id
    const link = baseUrl + identityID
    let dummy = document.createElement('textarea')
    document.body.appendChild(dummy)
    dummy.value = link
    dummy.select()
    document.execCommand('copy')
    document.body.removeChild(dummy)
    this.setState({
      copyText: 'Copied',
      copyClass: 'primary',
    })
  }

  render() {
    const { identity } = this.props
    const showContent = identity && identity.identity_accredited_investor_status
    let message = ''
    if (showContent && identity.identity_accredited_investor_status.raw_data !== null) {
      message = identity.identity_accredited_investor_status.raw_data.message
    }
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div style={{ borderRadius: '10px 10px 0 0' }} className='ibox-title'>
          <h5>Accredited Investor Status</h5>
          <div className='ibox-title-link'>
            {showContent ? (
              <Button size={'sm'} variant={this.state.copyClass} onClick={this.generateLink}>
                {this.state.copyText}
              </Button>
            ) : (
              ''
            )}
          </div>
        </div>
        <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content'>
          {showContent ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Status Message</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{identity.first_name + ' ' + identity.last_name}</td>
                  <td>
                    <StatusLabel status={identity.identity_accredited_investor_status.status} />
                  </td>
                  <td>{message}</td>
                </tr>
              </tbody>
            </Table>
          ) : (
            <span>{'N/A'}</span>
          )}
        </div>
      </div>
    )
  }
}

export default TXDetailsAccreditedStatus
